<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { ref, onMounted, onBeforeUnmount, watch, computed } from 'vue'

const props = defineProps({
  options: {
    type: Array as () => Array<{ label: string; value: any }>,
    default: () => []
  },
  modelValue: {
    type: Array as () => any[],
    default: () => []
  },
  placeholder: {
    type: String,
    default: 'Nhập từ khóa'
  },
  readOnly: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue'])

const values = ref([...props.modelValue])
const openPanel = ref(false)
const containerRef = ref<HTMLElement | null>(null)
const inputvalue = ref('')

const readOnly = computed(() => props.readOnly)

// Sync when modelValue changes from outside
watch(() => props.modelValue, (newVal) => {
  values.value = [...newVal]
})

// Emit when user selects/deselects
const toggleValue = (val: any) => {
  const index = values.value.indexOf(val)
  if (index >= 0) {
    values.value.splice(index, 1)
  } else {
    values.value.push(val)
  }
  emit('update:modelValue', [...values.value])
}


const handleClickOutside = (event: MouseEvent) => {
  if (containerRef.value && !containerRef.value.contains(event.target as Node)) {
    openPanel.value = false
  }
}

const handleKeyPress = (event: KeyboardEvent) => {
  if (event.key === 'Enter' && inputvalue.value.trim() !== '') {
    const newValue = inputvalue.value.trim()
    if (!values.value.includes(newValue)) {
      values.value.push(newValue)
      emit('update:modelValue', [...values.value])
      inputvalue.value = ''
    }
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})
onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<template>
  <div class="filter-tag-input" ref="containerRef">
    <div class="filter-tag-input__header" v-if="values && values.length > 0">
      <div
        class="item"
        v-for="(val, index) in values"
        :key="`selected-${index}`"
      >
        <div class="value">
          {{ options.find(opt => opt.value === val)?.label || val }}
        </div>
        <div class="icon" @click.stop="toggleValue(val)" v-if="!readOnly">
          <Icon icon="iconamoon:close-thin"/>
        </div>
      </div>

    </div>
    <input :readonly="readOnly" v-model="inputvalue" @keypress="handleKeyPress" :placeholder="props.placeholder" />
    <span  v-if="!readOnly && values && values.length > 0" class="clear-all" @click="values = []">Xóa hết</span>
  </div>
</template>

<style scoped>

</style>
